import { render, staticRenderFns } from "./DynaliveImport.vue?vue&type=template&id=a8049882&"
import script from "./DynaliveImport.vue?vue&type=script&lang=js&"
export * from "./DynaliveImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports